<div id="main-content-wrapper" [class.default-theme]="currentTheme == 'default-theme'">
	<fg-client-app-main-nav (settingsClicked)="openSettingsDrawer()">
		<div class="page-container" [style.margin-top]="isHeadless ? '0px' : ''">
			<router-outlet></router-outlet>
		</div>

		<fg-dynamic-footer [hidden]="isHeadless || isMenuLess"></fg-dynamic-footer>
	</fg-client-app-main-nav>
</div>

<!-- Settings Drawer -->
<mat-drawer #settingsDrawer mode="over" position="end" class="settings-drawer" [style.width.px]="300"
	[style.marginTop.px]="40">

	<div class="drawer-header">
		<span class="drawer-title">Settings</span>
		<button mat-icon-button aria-label="Close settings" (click)="settingsDrawer.close()">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<div class="drawer-content">
		<app-settings-panel></app-settings-panel>
	</div>
</mat-drawer>